module.exports = __webpack_public_path__ + "img/home-phone.035f6f1a.svg";